const MAP = {
  draft: "ss-pill-gray",
  awaiting_approval: "ss-pill-amber",
  approved: "ss-pill-green",
  rejected: "ss-pill-red",
  modification_requested: "ss-pill-amber",
  converted: "ss-pill-slate",
  sent: "ss-pill-slate",
  acknowledged: "ss-pill-green",
  in_progress: "ss-pill-purple",
  delivered: "ss-pill-green",
  invoiced: "ss-pill-sky",
  closed: "ss-pill-slate",
  pending: "ss-pill-amber",
  active: "ss-pill-green",
  open: "ss-pill-sky",
  awarded: "ss-pill-green",
  declined: "ss-pill-red",
  submitted: "ss-pill-sky",
  connected: "ss-pill-green",
  disconnected: "ss-pill-gray",
  healthy: "ss-pill-green",
  preparing: "ss-pill-amber",
  ready_to_ship: "ss-pill-sky",
  in_transit: "ss-pill-slate",
  delayed: "ss-pill-red",
  low: "ss-pill-amber",
  out_of_stock: "ss-pill-red",
  in_stock: "ss-pill-green",
  ok: "ss-pill-green",
  warning: "ss-pill-amber",
  over: "ss-pill-red",
  overridden: "ss-pill-purple",
  escalated: "ss-pill-red",
  not_received: "ss-pill-gray",
  partially_received: "ss-pill-amber",
  received: "ss-pill-green",
  received_with_issues: "ss-pill-red",
  complete: "ss-pill-green",
  pending_review: "ss-pill-amber",
  pending_approval: "ss-pill-amber",
  new: "ss-pill-sky",
  in_review: "ss-pill-amber",
  exported: "ss-pill-green",
  unassigned: "ss-pill-amber",
  unmatched: "ss-pill-amber",
  matched: "ss-pill-green",
  needs_reconnect: "ss-pill-amber",
  assigned: "ss-pill-green",
  excluded: "ss-pill-gray",
  needs_info: "ss-pill-amber",
  ready_for_sync: "ss-pill-sky",
  synced: "ss-pill-green",
  coded: "ss-pill-sky",
  paid: "ss-pill-green",
};

const LABELS = {
  awaiting_approval: "Awaiting Approval",
  modification_requested: "Modification Requested",
  in_progress: "In Progress",
  ready_to_ship: "Ready to Ship",
  in_transit: "In Transit",
  out_of_stock: "Out of Stock",
  in_stock: "In Stock",
  ok: "OK",
  over: "Over Budget",
  not_received: "Not Received",
  partially_received: "Partially Received",
  received_with_issues: "Received (Issues)",
  pending_review: "Pending Review",
  pending_approval: "Pending Approval",
  needs_info: "Needs Info",
  ready_for_sync: "Ready for Sync",
};

export default function StatusBadge({ status, testId }) {
  if (!status) return null;
  const cls = MAP[status] || "ss-pill-gray";
  const label = LABELS[status] || status.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  return (
    <span className={`ss-pill ${cls}`} data-testid={testId || `status-${status}`}>
      {label}
    </span>
  );
}
